<template>
    <el-dialog title="体检结果" :visible="visible" width="40%" @close="close">
        <el-form ref="form" :model="form" label-width="100px">
            <el-form-item label="名称" prop="name" :rules="{ required: true, message: '不能为空', trigger: 'blur' }">
                <el-input v-model.trim="form.name"></el-input>
            </el-form-item>
            <el-form-item label="关键词" prop="keywords" :rules="{ required: true, message: '不能为空', trigger: 'blur' }">
                <el-input v-model.trim="form.keywords"></el-input>
            </el-form-item>
            <el-form-item label="级别" prop="level" :rules="{ required: true, message: '不能为空', trigger: 'blur' }">
                <el-input-number v-model.trim="form.level" controls-position="right" />
            </el-form-item>
            <el-form-item label="告警" prop="alert" :rules="{ required: true, message: '不能为空', trigger: 'blur' }">
                <el-input-number v-model.trim="form.alert" controls-position="right" />
            </el-form-item>
            <el-form-item label="描述">
                <el-input type="textarea" v-model.trim="form.remarks"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="close">{{ $t('form.cancel') }}</el-button>
            <el-button @click="formSubmit" type="primary" :loading="loading" :disabled="loading">{{ $t('form.ok') }}
            </el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    props: {
        visible: {
            default: false
        },
        form: {
        },
        isNew: {
            default: false
        }
    },
    data() {
        return {
            loading: false
        }
    },
    methods: {
        async formSubmit() {
            const valid = await this.$refs['form'].validate().catch(() => false)
            if (!valid) return
            const resp = await this.$http.post('/settings/analysis', this.form)
            if (resp.data.code != 200) {
                this.$message.error(resp.data.msg)
            } else {
                this.$message.success('保存成功')
                this.$emit('update')
                this.$emit('close')
            }
        },
        close() {
            this.$emit('close')
        }
    }
}
</script>

<style scoped>

</style>
